import {APP_KEY, HTTP_URL, PHP_API_URL} from "../../../util/constants";
import request from "../../../util/request";
import Cookies from 'js-cookie';

export function getRegionListRequest(regionLevel,parentCode,callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append('caozuo', "quyulist");
  formData.append('quyu_jibie', regionLevel);
  formData.append('quyu_fuji_code', parentCode);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body:formData,
  }, callback);
}
export function getInfoListRequest(namekey,province,status,shenfen,offset,limit,callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'get_school_list');
  formData.append("namekey",namekey);
  formData.append("shengfen",province);
  formData.append("status", status);//(不选传空字符串，1:正常 2：删除 3：禁用)
  formData.append("user_type",shenfen);
  formData.append("offset", offset);
  formData.append("limit", limit);


  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}


//添加学校用户
export function addSchoolAdminRequest(
                                      school_name,
                                      dizhi,
                                      shengfen_name,
                                      shengfen_code,
                                      shi_name,
                                      shi_code,
                                      quxian_name,
                                      quxian_code,
                                      name,
                                      user_login,
                                      pwd,
                                      jifen,
                                      teacher_num,
                                      status,
                                      beizhu,
                                      callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'add_school_admin');
  formData.append("school_name",school_name);
  formData.append("dizhi",dizhi);
  formData.append("shengfen_name",shengfen_name);
  formData.append("shengfen_code",shengfen_code);
  formData.append("shi_name",shi_name);
  formData.append("shi_code",shi_code);
  formData.append("quxian_name",quxian_name);
  formData.append("quxian_code",quxian_code);
  formData.append("name",name);
  formData.append("user_login",user_login);
  formData.append("pwd",pwd);
  formData.append("jifen",jifen);
  formData.append("teacher_num",teacher_num);
  formData.append("status",status);
  formData.append("beizhu",beizhu);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}


//修改学校账号状态
export function changeAdminStatusRequest(
    username,
    status,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'jinyong_qiyong_school_admin');
  formData.append("username",username);
  formData.append("status",status);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}
//修改学校账号状态
export function changeSchoolTeacherRequest(
    username,
    status,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'jinyong_qiyong_school_teacher');
  formData.append("username",username);
  formData.append("status",status);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}
//删除学校用户
export function deleteAdminRequest(
    username,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'del_school_admin');
  formData.append("username",username);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}
//删除学校成员账号
export function deleteSchoolMemberRequest(
    username,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'del_school_teacher');
  formData.append("username",username);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}


//编辑学校管理员账号
export function editSchoolAdminRequest(
    username,
    school_name,
    dizhi,
    pwd,
    name,
    teacher_num,
    status,
    beizhu,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'update_school_admin');
  formData.append("username",username);
  formData.append("school_name",school_name);
  formData.append("dizhi",dizhi);
  formData.append("pwd",pwd);
  formData.append("name",name);
  formData.append("teacher_num",teacher_num);
  formData.append("status",status);
  formData.append("beizhu",beizhu);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}




//编辑学校成员账号
export function editSchoolMemberRequest(
    username,
    pwd,
    name,
    status,
    beizhu,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'admin_update_school_teacher');
  formData.append("username",username);
  formData.append("pwd",pwd);
  formData.append("name",name);
  formData.append("status",status);
  formData.append("beizhu",beizhu);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}


export function getAliOssTokenRequest( callback) {
  let formData = new FormData();
  formData.append('appkey', APP_KEY);
  formData.append('utoken', Cookies.get("userToken"));
  return request(PHP_API_URL+"/aliyun/osssts.php", {
    method: "POST",
    body: formData
  }, callback);
}
